// Language -> country whose flag people associate with it (ISO 3166-1 alpha-2, lowercase).
export const LANG_FLAG = {
  en: "gb", es: "es", fr: "fr", de: "de", it: "it", pt: "pt", nl: "nl", sv: "se",
  no: "no", da: "dk", fi: "fi", pl: "pl", cs: "cz", sk: "sk", hu: "hu", ro: "ro",
  bg: "bg", el: "gr", ru: "ru", uk: "ua", tr: "tr", ar: "sa", he: "il", fa: "ir",
  ur: "pk", hi: "in", bn: "bd", pa: "in", gu: "in", ta: "in", te: "in", kn: "in",
  ml: "in", mr: "in", ne: "np", si: "lk", th: "th", vi: "vn", km: "kh", lo: "la",
  my: "mm", id: "id", ms: "my", tl: "ph", zh: "cn", "zh-TW": "tw", ja: "jp",
  ko: "kr", sw: "ke", am: "et",
};

export const Flag = ({ code, country = "", className = "", testId }) => {
  const cc = country ? country.toLowerCase() : LANG_FLAG[code];
  if (!cc) return null;
  return (
    <img
      src={`https://flagcdn.com/w40/${cc}.png`}
      srcSet={`https://flagcdn.com/w80/${cc}.png 2x`}
      alt=""
      data-testid={testId}
      loading="lazy"
      width={24}
      height={18}
      onError={(e) => {
        e.currentTarget.style.visibility = "hidden";
      }}
      className={`h-[18px] w-6 shrink-0 rounded-[3px] object-cover ring-1 ring-white/15 ${className}`}
    />
  );
};
